import { EMPTY_VALUE, FieldSchema } from "../../../Schema";
import { Site } from "../external-sources/Sites";

export const siteTimezone: FieldSchema = {
  name: "siteTimezone",
  display: { displayed: false },
  data: {
    assignedValue: {
      getter: ({ siteName }) => {
        if (siteName) {
          return (siteName as Site).timeZone ?? EMPTY_VALUE;
        }
        return EMPTY_VALUE;
      },
      fields: ["siteName"],
    },
  },
  form: { label: "Site Timezone", disabled: true, displayed: false },
};
